import { render, staticRenderFns } from "./resource-filter-app.vue?vue&type=template&id=27daefad&"
import script from "./resource-filter-app.vue?vue&type=script&lang=js&"
export * from "./resource-filter-app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports